/**
* DevExpress HTML/JS Reporting (designer\bands\xrVerticalDetailBand.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { deserializeArray } from '@devexpress/analytics-core/analytics-utils';
import { GroupFieldModel } from './groupfield';
import { VerticalBandViewModel } from './xrVerticalBand';
export class VerticalDetailBandViewModel extends VerticalBandViewModel {
    dispose() {
        super.dispose();
        this.disposeObservableArray(this.sortFields);
        this.resetObservableArray(this.sortFields);
    }
    preInit(band, parent, serializer) {
        this.sortFields = deserializeArray(band.SortFields, (field) => { return new GroupFieldModel(field, serializer); });
    }
}
